import React, { useState } from "react";
import { Container, Row, Col, Table, Modal } from "react-bootstrap";
import { AiOutlineClose } from "react-icons/ai";
import "./QuotationView.css";
import { formatUTCDate_dmy, getImageUrl } from "../../../../MIS/Global";
import { calcSubTotal, getAddonNameById, getGstIs, getType } from "../../../../API/Model/quotaionModel";

const QuotationView = ({ quote = {} ,addons}) => {  
  const [quoteDetail, setQuoteDetail] = useState(quote);
  const [showModal, setShowModal] = useState(false);

  const handleImageClick = () => setShowModal(true);
  const handleClose = () => setShowModal(false);

  const quotation = {
    heading: "Jain Screen® Digital",
    address:
      "51, opp. Ajanta Transport, Mahaveer Nagar, Vakhar Bhag, Sangli, Maharashtra 416416",
    email: "info@company.com",
    phone: "+91-93722 12822",
    productImage:
      "https://jcbk.teeblanka.com/api/media/tbkProduct/1949red_blackSports_Event_T-Shirts.png",
    addons: [
      { id: 1, addon_name: "Logo Printing", addon_qty: 2, addon_rate: 50, addon_amount: 100 },
      { id: 2, addon_name: "Gift Wrapping", addon_qty: 1, addon_rate: 30, addon_amount: 30 },
      { id: 3, addon_name: "Extra Packaging", addon_qty: 3, addon_rate: 20, addon_amount: 60 },
      { id: 4, addon_name: "Express Delivery", addon_qty: 1, addon_rate: 100, addon_amount: 100 },
      { id: 5, addon_name: "Personal Note", addon_qty: 2, addon_rate: 15, addon_amount: 30 },
    ],
  };

  return (
    <>
      <Container className="quotation-view mt-4 mb-5">
        {/* Heading */}
        <Row className="text-center mb-3">
          <Col>
            <h4 className="fw-bold">{quotation.heading}</h4>
            <p className="mb-1">{quotation.address}</p>
            <p className="mb-0">Phone: {quotation.phone}</p>
          </Col>
        </Row>

        {/* Party Details */}
        <Row className="mb-3">
          <Col xs={12} md={6}>
            <p><strong>Shop Name:</strong> {quoteDetail?.shop_name || "Shop Name"}</p>
            <p><strong>Owner Name:</strong> {quoteDetail?.party_name}</p>
            <p><strong>Contact:</strong> {quoteDetail?.party_mob}</p>
            <p>
              <strong>Address:</strong> {quoteDetail?.party_address}, {quoteDetail?.party_city}, {quoteDetail?.party_state} - {quoteDetail?.party_pinCode}
            </p>
          </Col>

          <Col xs={12} md={6} className="text-md-end text-center">
            <p><strong>Order No:</strong> {quoteDetail.quote_no}</p>
            <p><strong>Order Date:</strong> {formatUTCDate_dmy(quoteDetail.quote_date)}</p>
            <p><strong>Expected Date:</strong> {quote?.due_date == "-" ?"NA":formatUTCDate_dmy(quote?.due_date)}</p>
            <p className={`${quoteDetail.cloth_name == ''?"d-none":''}`}><strong>Cloth:</strong> {quoteDetail?.cloth_name}</p>
            <p className={`${quoteDetail.quote_type == 0?"d-none":''}`}><strong>Type:</strong> {getType(quoteDetail.quote_type)}</p>
            <img
              src={getImageUrl(`${quoteDetail.product_image}`) }
              alt="Product"
              className="img-thumbnail product-image mt-2"
              onClick={handleImageClick}
            />
          </Col>
        </Row>

        {/* Product Table */}
        <div className="table-responsive">
          <Table striped bordered hover size="sm" className="product-table">
            <thead className="table-dark text-center">
              <tr>
                <th>Particular</th>
                <th className="d-none">HSN</th>
                <th>Size</th>
                <th>Qty</th>
                <th>Rate</th>
                <th>Amount</th>
              </tr>
            </thead>
            <tbody className="text-center">
              {quoteDetail.details?.map((item, index) => (
                <tr key={index}>
                  <td className="text-start">{item.item_name}</td>
                  <td className="d-none">{item.item_hsn}</td>
                  <td>{item.item_size}</td>
                  <td>{item.item_qty}</td>
                  <td>{item.item_rate.toLocaleString()}</td>
                  <td className="text-end">{item.item_amount.toLocaleString()}</td>
                </tr>
              ))}
              {quoteDetail.addons?.map((item, index) => (
                <tr key={`addon-${index}`}>
                  <td className="text-start">{getAddonNameById({addons_id: item?.addons_id, addons})}</td>
                  <td className="d-none"></td>
                  <td>Addon</td>
                  <td>{item?.addon_qty}</td>
                  <td>{Number(item?.addon_rate).toFixed(2)}</td>
                  <td className="text-end">{Number(item?.addons_amount).toFixed(2)}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>

        {/* Totals */}
        <Row className="justify-content-end">
          <Col xs={12} md={6}>
            <Table borderless size="sm" className="totals-table w-100">
              <tbody>
                <tr>
                  <td className="text-end fw-bold">Subtotal:</td>
                  <td className="text-end">
                    ₹{Number(calcSubTotal(quoteDetail?.sub_total,quoteDetail?.addons_total)).toLocaleString("en-IN", { minimumFractionDigits: 2 })}
                  </td>
                </tr>
                <tr>
                  <td className="text-end fw-bold">Addons:</td>
                  <td className="text-end">
                    ₹{Number(quoteDetail?.addons_total || 0).toLocaleString("en-IN", { minimumFractionDigits: 2 })}
                  </td>
                </tr>
                <tr className={`${getGstIs(quoteDetail?.s_gst)}`}>
                  <td className="text-end fw-bold">CGST:</td>
                  <td className="text-end">
                    ₹{Number(quoteDetail?.s_gst).toLocaleString("en-IN", { minimumFractionDigits: 2 })}
                  </td>
                </tr>
                <tr className={`${getGstIs(quoteDetail?.c_gst)}`}>
                  <td className="text-end fw-bold">SGST:</td>
                  <td className="text-end">
                    ₹{Number(quoteDetail?.c_gst).toLocaleString("en-IN", { minimumFractionDigits: 2 })}
                  </td>
                </tr>
                <tr className="table-dark">
                  <td className="text-end fw-bold">Grand Total:</td>
                  <td className="text-end fw-bold">
                    ₹{Number(quoteDetail?.grand_total).toLocaleString("en-IN", { minimumFractionDigits: 2 })}
                  </td>
                </tr>
              </tbody>
            </Table>
          </Col>
        </Row>
      </Container>

      {/* Modal */}
      <Modal show={showModal} onHide={handleClose} centered size="lg" contentClassName="border-0">
        <div className="position-relative">
          <AiOutlineClose
            onClick={handleClose}
            style={{
              position: "absolute",
              top: "10px",
              right: "15px",
              fontSize: "1.5rem",
              color: "#333",
              cursor: "pointer",
              zIndex: 1000,
            }}
          />
          <img
            src={quotation.productImage}
            alt="Large View"
            className="w-100 img-fluid"
            style={{ borderRadius: "6px", maxHeight: "90vh", objectFit: "contain" }}
          />
        </div>
      </Modal>
    </>
  );
};

export default QuotationView;
